import { ApiBaseService } from '@/services/ApiBase.service'
import {
  Company,
  ImpersonatableUser,
  ImpersonatableUsersRequest,
  User,
  UserPagedResult,
} from '@/classes/generated-models'

export class UserService extends ApiBaseService<User, UserPagedResult> {
  readonly apiController = 'users'

  async getImpersonatableUsers(request: ImpersonatableUsersRequest): Promise<ImpersonatableUser[]> {
    return this.post(request, 'impersonatable-users')
  }

  async getImpersonatableCompanies(): Promise<Company[]> {
    return this.get('impersonatable-companies')
  }

  async getCurrentUser(): Promise<User> {
    return this.get('current/profile')
  }
}
